<template>
  <div id="mobile-menu" ref="menu" :class="{ full : show }">
    <div class="header">
      <div class="left">
        <font-awesome-icon @click="() => show = !show" class="icon" :icon="faBars" />
      </div>
      <div class="right">
        <div class="d-flex justify-content-end">
          <right-header class="right" />
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="show" v-show="show">
        <search @searching="() => show = false"/>
        <nav-menu @clicked="() => show = false"/>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Search from '@/components/Header/Search';
import NavMenu from '@/components/SidePanel/NavMenu';
import RightHeader from '@/components/Header/RightHeader';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import eventBus from '@/eventBus';

export default {
  name: 'MobileMenu',
  components: {
    FontAwesomeIcon,
    Search,
    RightHeader,
    NavMenu,
  },
  setup() {
    const show = ref(false);
    const menu = ref(null);

    watch(show, () => {
      eventBus.$emit('body-overflow-hidden', show.value);
    });

    return {
      show,
      menu,
      faBars,
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#mobile-menu {
  overflow: hidden;
  background-color: $babyPowder;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 98;
  height: 49px;
  transition: all .3s ease-in;
  transition: all .5s ease-out;

  &.full {
    height: 100vh;
  }

  .header {
    background-color: $babyPowder;
    z-index: 98;
    position: fixed;
    width: 100%;
    box-shadow: 0px 3px 6px #00000029;
    padding: 6px 8px;

    .icon {
      width: 24px;
      height: 24px;
      cursor: pointer;
      margin-top: 6px;
    }

    .left {
      float: left;
      height:100%;
    }

    .right {
      float: right;
      height: 100%;
      user-select: none;
    }
  }

  .show {
    margin-top: 53px;
    padding-bottom: 20px;
    height: 100%;
    background-color: $geranium;
    overflow: scroll;
  }

  .fade-leave-to {
    transform: translateY(-1000px);
    opacity: 1;
  }

  .fade-enter {
    transform: translateY(-150px);
    opacity: 0;
  }

  .fade-enter-to {
    transition: all .6s ease-in-out;
    opacity: 1;
  }

  .fade-leave-active {
    transition: all .6s ease-in-out;
    opacity: 0.3;
  }
}
</style>
